import { isArray, isFunction } from '@mechhive/helpers';
import clsx from 'clsx';
import type { MouseEvent, PropsWithChildren } from 'react';
import { Link } from 'react-router';
import { MenuItemLabel } from './MenuItemLabel';
import { MenuItemTitle } from './MenuItemTitle';
import { MenuAccessory } from './MenuAccessory';

export type MenuItemProps = PropsWithChildren<{
  className?: string;
  to?: string;
  target?: string;
  onClick?: ( e: MouseEvent<HTMLAnchorElement> ) => void;
}>;

export const MenuItem = ( { className, children, to, target, onClick }: MenuItemProps ) => {
  const Items = isArray( children ) ? children : [ children ];
  const Label = Items.find( i => i?.type?.displayName === MenuItemLabel.displayName );
  const Title = Items.find( i => i?.type?.displayName === MenuItemTitle.displayName );
  const Accessory = Items.find( i => i?.type?.displayName === MenuAccessory.displayName )

  return (
    <Link
      to={ to ?? '#' }
      target={ target }
      className={ clsx(
        'min-h-12 border border-white/10 px-3 flex flex-row items-center bg-[#17193F4D] transition-colors duration-200 rounded-lg gap-5',
        Label && Title ? 'py-3' : 'py-2',
        {
          'cursor-pointer hover:border-white/30 hover:bg-[#17193F99]': isFunction( onClick ) || to != null,
        },
        className,
      ) }
      onClick={ ( e ) => {
        if ( to == null ) {
          e.preventDefault();
        }

        if ( isFunction( onClick ) ) {
          onClick( e );
        }
      } }>
      <div className={ 'flex-1 flex flex-col gap-2.5' }>
        {Label}
        {Title}
      </div>
      {Accessory}
    </Link>
  )
}
MenuItem.displayName = 'MenuItem';
